export const PERFORMED_SURF_CHECK_ACTION = 'PERFORMED_SURF_CHECK_ACTION';

/**
 * @description Can be used when a specific action that is not a route change can
 * trigger a surf check extension/consumption
 * @param {string} actionName
 */
export const performSurfCheckAction = (actionName) => ({
  type: PERFORMED_SURF_CHECK_ACTION,
  action: actionName,
});
